import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconSelector from '../IconSelector';
import styles from './index.scss';

const quickLinkTextClasses = classNames({
    [styles.linkText]: true,
    'quick-link-analytics': true,
});
const QuickLinks = ({ data }) => (
    <div className={styles.wrapper}>
        {data.map((link, i) => (
            <span className={styles.link} key={i}>
                <IconSelector linkIcon={link.linkIcon} />
                <a
                    className={quickLinkTextClasses}
                    href={link.url}
                    data-item-name={link.linkLabelTag}
                    data-group-name={link.linkGroup}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {link.linkLabel}
                </a>
            </span>
        ))}
    </div>
);

QuickLinks.propTypes = {
    data: PropTypes.array.isRequired,
};

export default QuickLinks;
